export { ApiClient } from './api/client';
export type { ApiConfig, ApiResponse } from './api/types';

export { I18n } from './i18n/core';
export type { TranslationKeys, LocaleData } from './i18n/types';

export { BaseComponent } from './components/base-component';
export { RoomVisualizer } from './components/room-visualizer';
export { Swap } from './components/swap';
export { YouzuLens } from './components/youzu-lens';
export { Youzu3DLens } from './components/youzu-3d-lens';
export { ProductCard } from './components/product-card';
export { MagicBackground } from './components/magic-background';
export { Youzu2dTo3d } from './components/youzu-2d-to-3d';

export { deepClone } from './utils/deep-clone';
export { EventEmitter } from './utils/event-emitter';
export { formatCurrency, formatNumber } from './utils/formatters';
export { dom } from './utils/dom';
export { blobUtils } from './utils/blob';

export { loadPolyfills } from './polyfills/loader';

// Import component classes for registration
import { RoomVisualizer as RoomVisualizerClass } from './components/room-visualizer';
import { Swap as SwapClass } from './components/swap';
import { YouzuLens as YouzuLensClass } from './components/youzu-lens';
import { Youzu3DLens as Youzu3DLensClass } from './components/youzu-3d-lens';
import { ProductCard as ProductCardClass } from './components/product-card';
import { MagicBackground as MagicBackgroundClass } from './components/magic-background';
import { Youzu2dTo3d as Youzu2dTo3dClass } from './components/youzu-2d-to-3d';

/**
 * Register all Youzu Web Components with the CustomElementRegistry
 * Call this function once when your application loads
 */
export function registerComponents(): void {
  if (typeof window === 'undefined') return;

  // Register Room Visualizer
  if (!customElements.get('youzu-room-visualizer')) {
    customElements.define('youzu-room-visualizer', RoomVisualizerClass);
  }

  // Register Swap
  if (!customElements.get('youzu-swap')) {
    customElements.define('youzu-swap', SwapClass);
  }

  // Register Youzu Lens
  if (!customElements.get('youzu-lens')) {
    customElements.define('youzu-lens', YouzuLensClass);
  }

  // Register Youzu 3D Lens
  if (!customElements.get('youzu-3d-lens')) {
    customElements.define('youzu-3d-lens', Youzu3DLensClass);
  }

  // Register Product Card
  if (!customElements.get('youzu-product-card')) {
    customElements.define('youzu-product-card', ProductCardClass);
  }

  // Register Magic Background
  if (!customElements.get('youzu-magic-background')) {
    customElements.define('youzu-magic-background', MagicBackgroundClass);
  }

  // Register 2D to 3D
  if (!customElements.get('youzu-2d-to-3d')) {
    customElements.define('youzu-2d-to-3d', Youzu2dTo3dClass);
  }
}

// Auto-register in browsers if not already registered
if (typeof window !== 'undefined') {
  // Use DOMContentLoaded to ensure registration happens after the document is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerComponents);
  } else {
    // DOM is already loaded, register immediately
    registerComponents();
  }
}
